import { FormEvent, useState } from 'react'
import { Col, Form, FormGroup, Input, Label } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Btn, H2, Image, P } from '../AbstractElements';
import { dynamicImage } from '../Utils';
import { EmailAddress, ForgotPassword } from '../Utils/Constants';
import { verifyCode, verifyEmail } from '../Services/AuthService';

export default function ForgotPasswordForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async(e: FormEvent) => {
        e.preventDefault()
        setLoading(true)

        if (message) {
            await handleVerifyCode();
        } else {
            await handleVerifyEmail();
        }
    };

    const handleVerifyEmail = async() => {
        try {
            const data: any = await verifyEmail(email);
            setMessage(data.message);
            toast.success("Email sent successfully");
            setLoading(false)
        } catch (err: any) {
            setLoading(false);
            toast.error(err.message || "Invalid email-address");
        }
    }

    const handleVerifyCode = async() => {
        try {
            const data: any = await verifyCode(email, code);
            toast.success(data.message);
            navigate(`${process.env.PUBLIC_URL}/reset-password?email_address=${email}`)
        } catch (err: any) {
            setLoading(false);
            toast.error(err.message || "Invalid email-address");
        }
    }

    return (
        <div>
            <div>
                <div className='logo'>
                    <Image className="img-fluid for-light m-auto" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                    <Image className="img-fluid for-dark" src={dynamicImage(`logo/logo.png`)} alt="looginpage" />
                </div>
            </div>
            <div className="login-main">
                <Form className="theme-form" onSubmit={handleSubmit}>
                    <H2 className="text-center">{ForgotPassword}</H2>
                    <P className="text-center">{"Enter your email-address"}</P>
                    
                    <FormGroup>
                        <Col><Label>{EmailAddress}</Label></Col>
                        <Input type="email" defaultValue={email} placeholder='Enter your email-address' onChange={(event) => setEmail(event.target.value)} readOnly={!!message} />
                    </FormGroup>

                    {message && <P className="text-center">{message}</P>}

                    {
                        message && 
                        <FormGroup>
                            <Col><Label>Verification Code</Label></Col>
                            <Input type="text" placeholder='Enter the verification code' onChange={(event) => setCode(event.target.value)} />
                        </FormGroup> 
                    }

                    <FormGroup className="mb-0 checkbox-checked">
                        <div className="text-end mt-3">
                            <Btn color='primary' className="w-100" block disabled={loading}> 
                                {loading ? (
                                    <>
                                        <i className="fa-solid fa-spinner fa-spin me-2"></i> Verifying...
                                    </>
                                ) : message ? 'Verify code' : 'Confirm email-address'}
                            </Btn>
                        </div>
                    </FormGroup>
                </Form>
            </div>
        </div>
    )
}